import userApi from '../../api/user'
import router from '../../plugins/router'

const state = () => ({
    loginValue: '',
    passwordScenario: null,
    mobileExist: false,
});

const getters = {};

const actions = {

    async login({commit}, data) {

        const loginData = await userApi.login(data);

        if(loginData){
            //update token
            commit('UPDATE_TOKEN', loginData['token'], { root: true });
            commit('UPDATE_USER_DATA', loginData['userData'], {root:true});
            commit('SET_SETTINGS', loginData['settings'], {root: true});
            commit('game/ADD_TO_QUESTIONS', loginData['settings']['starterQuestions'], {root: true});
            return true;
        }
        return false;
    },

    async register(_, data) {
        if(await userApi.register(data)){
            return true;
            //localStorage.setItem('userToken', rootState.token);
            //commit('UPDATE_USER_DATA', data, {root:true});
        }
        return false;
    },
    async logoutUser({commit}, logoutFromServer = true) {
        const loggedOut = logoutFromServer ? await userApi.logout() : true;
        if(loggedOut){
            commit('UPDATE_TOKEN', null, { root: true });
            router.go(0);
        }
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};